<sm-spinner [loading]="loading$"></sm-spinner>
<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" [title]="title"> </sm-page-header>
  <div class="flex flex-row gap-5">
    <!-- Form -->
    <div class="content w-full">
      <sm-form-builder [formObject]="globalFormObject"></sm-form-builder>
      <div [ngSwitch]="type">
        <sm-form-builder *ngSwitchCase="'FORM'" [formObject]="formObject"></sm-form-builder>
        <sm-data-table-builder *ngSwitchCase="'TABLE'" [dataTableObject]="datatableObject"></sm-data-table-builder>
        <div *ngSwitchDefault></div>
      </div>
    </div>
    <!-- Meta Blocks -->
    <!-- <div class="flex flex-col gap-2 w-1/4"></div> -->
  </div>
</div>
